import React, {RefObject} from "react";
import classNames from "classnames";
import { OrbitComponent } from '../../../base-components/orbit-component/orbit-component';
import {observer} from "mobx-react";
import {LiveCasinoFilterButtonIconBox} from "./boxes/live-casino-filter-button-icon/live-casino-filter-button-icon.box";
import {LiveCasinoFilterButtonLabelBox} from "./boxes/live-casino-filter-button-label/live-casino-filter-button-label.box";
import {ACTIVE} from "../../../../themes/css-global-classes";
import {LiveCasinoArenaNavbarButtonBox} from "./boxes/live-casino-arena-navbar-button/live-casino-arena-navbar-button.box";
import {Link} from "../../../raw-components/link/link";

export interface LiveCasinoArenaNavbarButtonProps {
    label: string;
    filter: string;
    isActiveTab: boolean;
    seoPage: string;
    buttonLabelRef: RefObject<HTMLDivElement>;
    onClick: () => void;
};

@observer
export class LiveCasinoArenaNavbarButton extends OrbitComponent<LiveCasinoArenaNavbarButtonProps> {
    private buttonIconMap = new Map([
        ["roulette", this.services.theme.currentTheme.icons.rouletteIcon],
        ["poker-games", this.services.theme.currentTheme.icons.pokerIcon],
        ["blackjack", this.services.theme.currentTheme.icons.blackjackIcon],
        ["baccarat", this.services.theme.currentTheme.icons.baccaratIcon],
        ["elite-lounge", this.services.theme.currentTheme.icons.eliteLoungeIcon],
        ["game-shows", this.services.theme.currentTheme.icons.gameShowsIcon],
        ["new-games", this.services.theme.currentTheme.icons.newGamesIcon],
        ["top-evo-games", this.services.theme.currentTheme.icons.topGamesIcon],
        ["exclusive", this.services.theme.currentTheme.icons.tripleEightExclusiveIcon]
    ]);
    private _getButtonIcon() {
        const iconKey = this.props.label.toLowerCase().trim().replace(/(_|\s)/g, "-");
        return this.buttonIconMap.has(iconKey) ? this.buttonIconMap.get(iconKey)! : this.services.theme.currentTheme.icons.topGamesIcon;
    }

    onFilterClicked(isActive: boolean) {
        if(!isActive) {
            this.services.analytics.sendAnalytics('Navigation', 'Live Tab', this.props.label);
            this.props && this.props.onClick();
        }
    }

    render() {
        let IconComponent = this._getButtonIcon();
        return <Link box={LiveCasinoArenaNavbarButtonBox}
            href={this.props.seoPage}
            className={classNames('cy-live-casino-filter-button' + (this.props.filter? ('-' + this.props.filter): ''))}
            onClick={()=> this.onFilterClicked(this.props.isActiveTab)}
        >
            <LiveCasinoFilterButtonIconBox isActiveTab={this.props.isActiveTab}>
                <IconComponent size={this.services.device.isMobile ? 3.8 : 5} sizeIsHeight />
            </LiveCasinoFilterButtonIconBox>
            <LiveCasinoFilterButtonLabelBox ref={this.props.buttonLabelRef} className={classNames({[ACTIVE]: this.props.isActiveTab})}>
                {this.services.translation.translate(this.props.label)}
            </LiveCasinoFilterButtonLabelBox>
        </Link>;
    }
}
